import { render, staticRenderFns } from "./oilCardBill.vue?vue&type=template&id=ed5f4088&scoped=true&"
import script from "./oilCardBill.vue?vue&type=script&lang=js&"
export * from "./oilCardBill.vue?vue&type=script&lang=js&"
import style0 from "./oilCardBill.vue?vue&type=style&index=0&id=ed5f4088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5f4088",
  null
  
)

export default component.exports